export const setSlideState = function ($this, item) {
    const elem = item.el;

    if (Math.floor($this.virtualSize) > Math.floor($this.width)) {
        if ($this.isBeginning) elem.setAttribute('data-position', 'start');
        else if ($this.isEnd) elem.setAttribute('data-position', 'end');
        else elem.setAttribute('data-position', 'center');
    } else item.el.setAttribute('data-position', 'hide');
};